<template>
  <div class="revoke">
    <span v-if="message.flow === 'in'">{{ message.nick || message.from }}</span>
    <span v-else-if="message.from === message.revoker">{{
      TUITranslateService.t("TUIChat.您")
    }}</span>
    <span v-else>{{ message.revoker }}</span>
    <span>{{ TUITranslateService.t("TUIChat.撤回了一条消息") }}</span>
    <span
      v-if="message.flow === 'out' && isEditMsg"
      class="edit"
      @click="messageEdit"
    >{{ TUITranslateService.t("TUIChat.重新编辑") }}</span>
  </div>
</template>

<script lang="ts">
import vue from '../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '../../../../@aidesk/uikit-engine';
const __sfc_main = {};
__sfc_main.props = {
  isEdit: {
    type: Boolean,
    default: () => false
  },
  messageItem: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    watchEffect,
    ref
  } = vue;
  const props = __props;
  const message = ref<IMessageModel>();
  const isEditMsg = ref(false);
  const emits = __ctx.emit;
  watchEffect(() => {
    message.value = props.messageItem;
    isEditMsg.value = props.isEdit;
  });
  const messageEdit = () => {
    emits('messageEdit');
  };
  return {
    TUITranslateService,
    message,
    isEditMsg,
    messageEdit
  };
};
export default __sfc_main;
</script>
<style lang="scss" scoped>
@import "../../style/common";

.revoke {
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
  white-space: pre;

  .edit {
    padding: 0 5px;
    color: #006eff;
  }
}
</style>
